export const HAS_EXTRA_SPACES = /\s{2,}/g;

export const HAS_LEADING_OR_TRAILING_SPACES = /(^[\s]+)|([\s]+$)/g;

export const IS_NUMERIC = /\D/g;
